import * as z from 'zod';

export const VendedorSchema = z.object({
  id_vendedor: z.number(),
  parametro: z.string(),
  name: z.string(),
  email: z.string(),
  nm_razao_social: z.string(),
  id_corretora: z.number(),
  nu_cd_vendedor_s4_e: z.number(),
  //dependentes: z.optional(z.array(dependentsSchema)),
});
